import { useEffect } from 'react';
export function useMessageListener(fn) {
    useEffect(function () {
        window.addEventListener('message', fn);
        return function () {
            window.removeEventListener('message', fn);
        };
    }, [fn]);
}
